/**
 * Line item property used to record where an add-to-cart request came from.
 *
 * Shopify hides line item properties whose name starts with an underscore from
 * the storefront and checkout, so the marker stays out of customer-facing
 * output while remaining visible in `/cart.js`, the order admin and webhooks —
 * which is where it is useful when debugging "how did this line get here?".
 *
 * Values follow a `<surface>:<function>` convention, e.g.
 * `quick-add-modal:addToCart`.
 */
export const CART_SOURCE_PROPERTY = '_source';

/**
 * Merge a `_source` marker into a line item's properties.
 *
 * An already-present `_source` is kept, so a caller that tagged its items with
 * something more specific upstream is never overwritten by a generic default.
 *
 * @param properties Existing line item properties, if any.
 * @param source Origin marker, e.g. `mini-cart:cart-service`.
 * @returns A new properties object including `_source`.
 */
export function withCartSource(
  properties: Record<string, any> | null | undefined,
  source: string,
): Record<string, any> {
  return { [CART_SOURCE_PROPERTY]: source, ...(properties ?? {}) };
}
